import React, { Component } from 'react';
import { Route, Routes } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import Landing from './components/refundestimator/Landing';
import { Header } from './components/Header';
import Footer from './components/Footer';
import './css/global.css';
import './css/datepicker.css';
import './custom.css'

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Header />
                <main role="main" style={{ minHeight: "calc(100vh - 235px)", position: "relative" }}>
                    <Routes>
                        <Route exact path='/' element={<Landing />} />
                        <Route path='/counter' element={<Counter />} />
                        <Route path='/fetch-data' element={<FetchData />} />
                    </Routes>
                </main>
                <Footer />
            </Layout>
        );
    }
}
